var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 448 910 50q13-13 32-13t32 13q13 13 13 32t-13 32L576 512l398 398q13 13 13 32t-13 32q-13 13-32 13t-32-13L512 576 114 974q-13 13-32 13t-32-13q-13-13-13-32t13-32l398-398L50 114q-13-13-13-32t13-32q13-13 32-13t32 13l398 398z"
  })));
};
export { SvgX as ReactComponent };
export default __webpack_public_path__ + "7d14aabebf5247fb9d961157230bb726.svg";